import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BaseQueryErrorHandler } from "./@utils/BaseQueryErrorHandler";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: "/api/v2/ovs-bot-pipeline/pipeline/",
  prepareHeaders: (headers) => {
    headers.set("Content-Type", "application/json");

    return headers;
  },
});

const baseQuery = BaseQueryErrorHandler(rawBaseQuery);

export const drsListsApi = createApi({
  reducerPath: "drsListsApi",
  baseQuery,
  endpoints: (builder) => ({
    getDRSLists: builder.query({
      query: () => `/`,
    }),
    putBunchStatusUpdate: builder.mutation({
      query: ({ listsIDs, newStatus }) => ({
        url: "/update-status",
        method: "PATCH",
        body: {
          document_ids: listsIDs,
          new_status: newStatus,
          status_type: "drs",
        },
      }),
    }),

    putNewGoal: builder.mutation({
      query: ({ listID, newGoal }) => ({
        url: "/list",
        method: "PATCH",
        body: {
          document_ids: [listID],
          updated_field: "goal",
          new_value: Number.parseInt(newGoal),
        },
      }),
    }),
    putNewDeadline: builder.mutation({
      query: ({ listsIDs, newDeadline }) => ({
        url: "/list",
        method: "PATCH",
        body: {
          document_ids: listsIDs,
          updated_field: "deadline",
          new_value: newDeadline,
        },
      }),
    }),
    putNewComment: builder.mutation({
      query: ({ listID, newComment }) => ({
        url: "/list",
        method: "PATCH",
        body: {
          document_ids: [listID],
          updated_field: "operator_comment",
          new_value: newComment,
        },
      }),
    }),
    deleteList: builder.mutation({
      query: ({ deletingLists }) => ({
        url: "/list",
        method: "DELETE",
        body: { lists: deletingLists },
      }),
    }),
    postNewList: builder.mutation({
      query: ({
        block,
        campaignBlock,
        list,
        link,
        goal,
        listType,
        deadline,
        region,
        isDrsMode,
      }) => ({
        url: "/list",
        method: "POST",
        body: {
          block,
          campaign_block: campaignBlock,
          deadline,
          goal: Number.parseInt(goal),
          list_link: link,
          list_name: list,
          list_type: listType,
          region,
          is_drs_mode: isDrsMode,
        },
      }),
    }),
    putNewOvStatus: builder.mutation({
      query: ({ listID, newOvStatus }) => ({
        url: "/list",
        method: "PATCH",
        body: {
          document_ids: [listID],
          updated_field: "ov_status",
          new_value: !!newOvStatus,
        },
      }),
    }),
    patchResetPhantomStatuses: builder.mutation({
      query: () => ({
        url: "/reset-phantom-statuses",
        method: "PATCH",
      }),
    }),
  }),
});

export const {
  useGetDRSListsQuery,
  usePutBunchStatusUpdateMutation,
  usePutNewGoalMutation,
  usePutNewDeadlineMutation,
  usePutNewCommentMutation,
  useDeleteListMutation,
  usePostNewListMutation,
  usePutNewOvStatusMutation,
  usePatchResetPhantomStatusesMutation,
} = drsListsApi;
